// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3-g0a","nav-separator":"classes_nav-separator__3Sxv3","nav":"classes_nav__Ax370","side-menu-nav":"classes_side-menu-nav__3A-oF"};